import { useState } from "react";
import { FaPlus, FaTrashAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { IoFilterCircle } from "react-icons/io5";

const tabs = ["Vendors", "Open Order", "Receipt", "Credit Balance"];

const dummyVendors = [
  { id: 1, name: "John Doe", credit: "$30" },
  { id: 2, name: "Jane Smith", credit: "$120" },
  { id: 3, name: "Vendor X", credit: "$250" },
];

const openOrders = [
  { id: 1, name: "John DOE", date: "05 May 2024 - 09:23PM", status: "Send Request" },
  { id: 2, name: "John DOE", date: "05 May 2024 - 09:23PM", status: "Ready to Pay", amount: "$27.99" },
  { id: 3, name: "John DOE", date: "05 May 2024 - 09:23PM", status: "Paid Successfully", amount: "$27.99" },
];

const VendorList = () => {
  const [activeTab, setActiveTab] = useState("Vendors");
  const [vendors, setVendors] = useState(dummyVendors);
  const [search, setSearch] = useState("");
  const [showFilter, setShowFilter] = useState(false);

  const navigate = useNavigate();

  const handleDelete = (id) => {
    setVendors((prev) => prev.filter((v) => v.id !== id));
  };

  const filteredVendors = vendors.filter((v) =>
    v.name.toLowerCase().includes(search.toLowerCase())
  );

  const filteredOrders = openOrders.filter((v) =>
    v.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen px-4 py-4 bg-white">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <button className="text-lg font-semibold">&larr;</button>
        <h1 className="text-lg font-bold">Vendor Management</h1>
        <div className="w-6" />
      </div>

      {/* Tabs */}
      <div className="flex gap-2 mb-4 overflow-x-auto">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2 rounded-full text-sm whitespace-nowrap ${
              activeTab === tab ? "bg-primary text-white" : "bg-gray-200 text-gray-700"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>


<div className="flex items-center justify-between gap-2">
      {/* Search */}
      <input
        type="text"
        placeholder="Search"
        className="w-full mb-4 px-4 py-2 border rounded-lg text-sm"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
<IoFilterCircle className="text-5xl text-primary"  onClick={() => setShowFilter(true)}/>
</div>


      {/* Content Based on Tab */}
      <div className="space-y-4">
        {activeTab === "Vendors" &&
          (filteredVendors.length > 0 ? (
            filteredVendors.map((vendor) => (
              <div
                key={vendor.id}
                className="flex items-center justify-between p-3 border rounded-lg shadow-sm hover:shadow-md transition"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-primary font-bold">
                    {vendor.name.charAt(0)}
                  </div>
                  <div>
                    <p className="font-semibold">{vendor.name}</p>
                    <p className="text-sm text-gray-600">{vendor.credit}</p>
                  </div>
                </div>
                <button
                  onClick={() => handleDelete(vendor.id)}
                  className="text-primary hover:text-red-800"
                >
                  <FaTrashAlt />
                </button>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">No vendors found.</p>
          ))}

        {activeTab === "Open Order" &&
          (filteredOrders.length > 0 ? (
            filteredOrders.map((item) => (
              <div
                key={item.id}
                className="border p-4 rounded-lg shadow-sm flex justify-between items-center"
              >
                <div>
                  <p className="font-semibold">I - #000000</p>
                  <p className="text-sm text-gray-500">{item.name}</p>
                  <p className="text-xs text-gray-400">{item.date}</p>
                </div>
                <div className="text-right">
                  {item.amount && (
                    <p className="text-green-600 font-bold">{item.amount}</p>
                  )}
                  <span
                    className={`inline-block mt-1 text-xs px-2 py-1 rounded-full ${
                      item.status === "Paid Successfully"
                        ? "bg-green-100 text-green-700"
                        : item.status === "Ready to Pay"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-primary text-red-700"
                    }`}
                  >
                    {item.status}
                  </span>
                  <div className="flex gap-2">
 <button className="bg-primary rounded-full text-red-700 px-2 my-2 py-1">Item-1</button>
 <button className="bg-primary rounded-full text-red-700 px-2 my-2 py-1">Unit-50</button>
                  </div>
                 
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500">No orders found.</p>
          ))}

        {activeTab !== "Vendors" && activeTab !== "Open Order" && (
          <p className="text-center text-gray-500">No data for this tab yet.</p>
        )}
      </div>

      {/* Floating Add Button */}
      <button
        className="fixed bottom-6 right-6 bg-primary text-white p-4 rounded-full shadow-lg"
        onClick={() =>
          activeTab === "Vendors"
            ? navigate("/addvendor")
            : navigate("/addpurchase")
        }
      >
        <FaPlus />
      </button>
      {showFilter && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
    <div className="bg-white rounded-xl p-6 w-full max-w-md relative">
      <button
        onClick={() => setShowFilter(false)}
        className="absolute top-3 right-4 text-xl text-gray-500"
      >
        &times;
      </button>

      <h2 className="text-lg font-bold mb-4">Filter</h2>

      <div className="space-y-4">
        {/* Invoice ID */}
        <input
          type="text"
          placeholder="Invoice ID"
          className="w-full px-4 py-2 border rounded"
        />

        {/* Date Range */}
        <div className="flex gap-2">
          <input
            type="date"
            className="w-1/2 px-4 py-2 border rounded"
          />
          <input
            type="date"
            className="w-1/2 px-4 py-2 border rounded"
          />
        </div>

        {/* Status Buttons */}
        <div className="space-y-2">
          <p className="text-sm font-medium">Status</p>
          <div className="flex flex-wrap gap-2">
            {[
              "Send Request",
              "Order Requested",
              "Ready to Pay",
              "Paid Successfully",
              "Order Rejected",
            ].map((status) => (
              <button
                key={status}
                className={`px-3 py-1 text-xs rounded-full border text-gray-700 hover:bg-primary`}
              >
                {status}
              </button>
            ))}
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-between pt-2">
          <button
            className="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300"
            onClick={() => {
              // Clear logic
              setShowFilter(false);
            }}
          >
            Reset
          </button>
          <button
            className="px-4 py-2 text-sm bg-primary text-white rounded hover:bg-red-700"
            onClick={() => {
              // Apply logic here
              setShowFilter(false);
            }}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  </div>
)}

    </div>
  );
};

export default VendorList;
